import { z } from 'zod';
import { MAX_INPUT_TEXT_LENGTH } from '@mews/framework';

export enum GroupNameFormKeys {
    groupName = 'groupName',
}

export const groupNameFormSchema = z.object({
    [GroupNameFormKeys.groupName]: z.string().min(1).max(MAX_INPUT_TEXT_LENGTH),
});

export type GroupNameFormValues = z.infer<typeof groupNameFormSchema>;
